export default {"src":"/_next/static/media/404-page-not-found.6ea7368c.svg","height":280,"width":500,"blurWidth":0,"blurHeight":0};